module.exports = {
      id: "newslettericon-usage",
      viewBox: "0 0 48 47.861",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#newslettericon",
      toString: function () {
        return this.url;
      }
    }